import React, { useState, useEffect } from 'react';
import { Box, Container, Paper, Typography, TextField, Button, Divider, Alert } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useAuth } from '@contexts/AuthContext';

export default function ClinicProfile() {
  const { user } = useAuth();
  const [name, setName] = useState<string>('');
  const [cui, setCui] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [phone, setPhone] = useState<string>('');
  const [address, setAddress] = useState<string>('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  useEffect(() => {
    // Preîncarcă valorile existente dacă sunt disponibile pe user sau vor veni dintr-un serviciu dedicat
    setEmail(user?.email || '');
    setPhone(''); // Phone va fi încărcat din serviciul dedicat
  }, [user]);

  const handleSave = async () => {
    try {
      setSaving(true);
      setError(null);
      setSuccess(null);
      // TODO: apel la services/clinic-admin/profileService.ts pentru salvare
      await new Promise(r => setTimeout(r, 500));
      setSuccess('Profilul clinicii a fost salvat.');
    } catch (e: any) {
      setError('Eroare la salvarea profilului clinicii');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Container maxWidth="lg" sx={{ py: 3 }}>
      <Typography variant="h4" fontWeight={700} sx={{ mb: 2 }}>
        Profil Clinică
      </Typography>

      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}

      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" sx={{ mb: 2 }}>Date clinică</Typography>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 6 }}>
            <TextField label="Nume clinică" fullWidth value={name} onChange={(e) => setName(e.target.value)} />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <TextField label="CUI" fullWidth value={cui} onChange={(e) => setCui(e.target.value)} />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <TextField label="Email" fullWidth value={email} onChange={(e) => setEmail(e.target.value)} />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <TextField label="Telefon" fullWidth value={phone} onChange={(e) => setPhone(e.target.value)} />
          </Grid>
          <Grid size={12}>
            <TextField label="Adresă" fullWidth value={address} onChange={(e) => setAddress(e.target.value)} />
          </Grid>
        </Grid>

        <Divider sx={{ my: 3 }} />

        <Box display="flex" justifyContent="flex-end" gap={2}>
          <Button variant="contained" onClick={handleSave} disabled={saving}>
            {saving ? 'Se salvează...' : 'Salvează'}
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}


